import { createResizedImageCrossOrigin } from './imageLoader';
import colors from '../colorsBg.json';
import furs from '../colorsFur.json';

export async function getColor(name) {
    const colorData = colors.find((data) => data.name === name);
    return colorData ? colorData.value : '';
}

export async function getFurImage(name) {
    const furData = furs.find((data) => data.name === name);
    return furData ? furData.value1 + "|" + furData.value2 : '';
}

export async function downloadImage(canvas, filename, extendedImage) {
    let dataURL = canvas;
  
    if (extendedImage === 0) {
      dataURL = await createResizedImageCrossOrigin(dataURL, 1000, 1000);
    } else if (extendedImage === 1) {
      dataURL = await createResizedImageCrossOrigin(dataURL, 1600, 900);
    }
  
    // Create a link element
    const link = document.createElement('a');
    link.download = filename;
    link.href = dataURL;
    
    // Add the link to the DOM and click it
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export async function downloadGIF(gif, filename) {
    const a = document.createElement('a');
    a.style.display = 'none';
    a.href = gif;
    a.download = filename;

    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}